module.exports = __webpack_public_path__ + "static/media/LFEX-name-light.67a5d9d7.png";